import createNamespaceContext from './helper/createNamespaceContext';
export var AI_MATE_CONTEXT = 'aiMateCtx';
export var AIMateAnalyticsContext = createNamespaceContext(AI_MATE_CONTEXT, 'AIMateAnalyticsContext');